import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { router } from "./plugins/router";
import store from "./store/store";
import {chartUtils} from "./mixins/chartUtils";
// console 其餘資訊
Vue.config.productionTip = false;
Vue.mixin(chartUtils);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
